//requests all order information from ecommerce platform when user loads home page.
//deprecated
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const OrdersContext = createContext();

export const useOrders = () => useContext(OrdersContext); // Custom hook for using the Orders context

export const OrdersProvider = ({ children }) => {
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem("authToken");
        const user_id = localStorage.getItem("user");
        const response = await axios.get(`${apiUrl}/api/fetch_orders/`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          params: { state: user_id },
        });
        // Assuming the data structure is similar to Shopify's GraphQL response
        const fetchedOrders = response.data.data.orders.edges || []; // Adjust based on your API response structure
        setOrders(fetchedOrders);
      } catch (error) { console.error("Error fetching orders:", error); }
      finally { setLoading(false); }
    };
    fetchOrders();
  }, []);
  return (<OrdersContext.Provider value={{ orders, loading }}>{children}</OrdersContext.Provider>);
};

export default OrdersProvider;
